import * as generic from "@/store/generic/mutations/result-status.js";

export const setError = generic.setError;
export const setSuccess = generic.setSuccess;
export const setProcessing = generic.setProcessing;

export function storeLiveclassSchedules(state, data) {
  state.liveclasses = data;
}

export function setLiveClass(state, data) {
  state.currentLiveClass = data;
}

export function purgeLiveClass(state) {
  state.liveclasses = [];
  state.currentLiveClass = {};
}
